import React, { useState,useEffect } from 'react';
import { makeAPI } from '../../services/api';
import { Link } from 'react-router-dom';
const GameJamListing = () => {
    const PAGE_SIZE = 5;
    const [JamData, setJamData] = useState([]);
    const [offset, setOffset] = useState(0);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [total,settotal] = useState(0);

    useEffect(() => {
        fetchJams(0);
    }, []);

    const fetchJams = async (newOffset) => {
        if (loading) return;
        setLoading(true);

        try {

            const res = await makeAPI(
                '/api/gamejam_listing',
                'post',
                false,
                { offset: newOffset, limit: PAGE_SIZE }
            );

            if (res?.data?.length > 0) {

                setJamData(prev => [...prev, ...res.data]);
                setOffset(newOffset + PAGE_SIZE);
                setHasMore(res.hasMore);
                settotal(res.total)
            } else {

                setHasMore(false);

            }

        } catch (error) {

            console.error("Error fetching jams", error);

        } finally {

            setLoading(false);

        }

    };

    const handleLoadMore = () => {
        fetchJams(offset);
    };

    const formatSubmittedGameTitle = (title, maxChars = 25) => {
        if (!title) return "";
        return title.length > maxChars ? `${title.slice(0, maxChars).trim()}...` : title;
    };

    return (
        <section className="games-sec">
            <style>{css}</style>
            <p className='container' style={{ backgroundColor: "transparent", cursor: "pointer" }} onClick={() => {
        window.history.back();
      }}><i className="fa-solid fa-arrow-left"></i> {"BACK"}</p>
            <div className="si">
                <div className="games-header rv">
                    <div>
                        {/* <span className="sec-eyebrow">Community Events</span> */}
                        <h2 className="sec-title">Game<span className="hl">Jam Listings</span></h2>
                        <div className="sec-divider"></div>
                    </div>
                    <div className="games-filter">
                        <div className="gf-btn active">{JamData.length}/{total} shown</div>
                    </div>
                </div>

                <div className="games-grid rv">
                    {JamData.map((jam, index) => (
                      <div key={index}>
                        <article  className="game-card rv" style={{ "--d": `${index * 70}ms` }} onClick={()=> window.location.href = `/gamejam-details/${jam.sub_id}`}>
                            <div className="gc-thumb">
                                <img
                                    src={jam.game_thumbnail+`?v=${jam.crd_on}`}
                                    alt={`${jam.title} banner`}
                                    className="gc-thumb-img"
                                />
                                <div className="gc-top">
                                    {/* <div className="gc-rank rnew">Jam</div> */}
                                    {/* <div className="gc-status">Open</div> */}
                                </div>
                                <Link
                                    to={`/gamejam-details/${jam.sub_id}`}
                                    className="gc-play-btn"
                                    aria-label={`View ${jam.title}`}
                                />
                            </div>
                            <div className="gc-info">
                                <div className="gc-name" title={jam.title}>{formatSubmittedGameTitle(jam.title)}</div>
                                {/* <div className="gc-meta">
                                    <div className="gc-votes">
                                        <span className="gc-votes-icon">#</span>
                                        {String(index + 1).padStart(2, '0')}
                                    </div>
                                    <div className="gc-tag gt-a">Game Jam</div>
                                </div> */}
                                <div className="gc-play-row">
                                    <Link
                                        to={`/gamejam-details/${jam.sub_id}`}
                                        className="gc-play-full"
                                    >
                                       <span className="play-arrow"></span> Play now 
                                    </Link>
                                    <button
                                        className="gc-vote-btn"
                                        type="button"
                                        aria-label={`${jam.votes ?? 0} votes`}
                                        title={`${jam.votes ?? 0} votes`}
                                    >
                                        <i className="fas fa-star" aria-hidden="true"></i>
                                        {jam.votes ?? 0}
                                    </button>
                                </div>
                            </div>
                        </article>
                      </div>
                    ))}
                    {JamData.length === 0 && <p>No Game Jam submissions.</p>}
                </div>
            </div>

            <div className="games-footer">
                <button
                    type="button"
                    onClick={handleLoadMore}
                    className={hasMore ?"gj-loadmore-btn":"d-none"}
                    disabled={!hasMore || loading}
                >
                    {loading ? 'Loading...' : hasMore ? 'Load More' : 'All loaded'} 
                </button>
            </div>
        </section>
    );
};

export default GameJamListing;

const css = `
.games-sec {
  --black:  #080808;
  --dark:   #0f0f0f;
  --dark2:  #161616;
  --dark3:  #1e1e1e;
  --or:     #f97316;
  --or2:    #fb923c;
  --red:    #ef4444;
  --gold:   #f59e0b;
  --silver: #94a3b8;
  --bronze: #b45309;
  --tx:     #ffffff;
  --tx2:    rgba(255,255,255,.7);
  --tx3:    rgba(255,255,255,.4);
  --bd:     rgba(249,115,22,.2);
  --bd2:    rgba(249,115,22,.45);
  --clip-both: polygon(0 0, calc(100% - 16px) 0, 100% 16px, 100% 100%, 16px 100%, 0 calc(100% - 16px));
  background: var(--dark);
  position: relative;
  overflow: hidden;
  padding: 80px 80px 96px;
  color: var(--tx);
  font-family: 'Barlow', sans-serif;
}
.games-sec::before {
  content: ''; position: absolute; inset: 0; z-index: 0; pointer-events: none;
  background:
    radial-gradient(ellipse 60% 50% at 50% 0%, rgba(249,115,22,.06) 0%, transparent 65%),
    repeating-linear-gradient(90deg, transparent, transparent 119px, rgba(249,115,22,.03) 119px, rgba(249,115,22,.03) 120px);
}
.si { max-width: 1280px; margin: 0 auto; position: relative; z-index: 1; }

.sec-eyebrow {
  display: flex; align-items: center; gap: 12px;
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 11px; letter-spacing: 4px; text-transform: uppercase;
  color: var(--or); margin-bottom: 12px;
}
.sec-eyebrow::before { content: ''; width: 28px; height: 2px; background: var(--or); }
.sec-title {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
  font-size: clamp(28px, 4vw, 52px); letter-spacing: .5px;
  text-transform: uppercase; line-height: 1.0; color: var(--tx);
}
.sec-title .hl { color: var(--or); }
.sec-divider {
  width: 64px; height: 3px; margin: 16px 0 24px;
  background: linear-gradient(90deg, var(--or), rgba(249,115,22,.2));
}

.games-header {
  display: flex; align-items: flex-end; justify-content: space-between;
  margin-bottom: 32px; position: relative; z-index: 1; gap: 20px;
}
.games-filter { display: flex; gap: 6px; align-items: center; }
.gf-btn {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 11px; letter-spacing: 2px; text-transform: uppercase;
  padding: 7px 16px;
  background: transparent; border: 1px solid rgba(255,255,255,.1); color: var(--tx3);
}
.gf-btn.active {
  background: var(--or); color: #fff; border-color: var(--or);
}

.games-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, 220px);
  gap: 20px;
  justify-content: center;
  align-items: start;
  position: relative; z-index: 1;
}
.game-card {
  width: 220px;
  background: var(--dark2);
  border: 1px solid rgba(255,255,255,.09);
  border-radius: 8px;
  cursor: pointer;
  transition: transform .3s ease, border-color .3s ease, box-shadow .3s ease;
  display: flex; flex-direction: column;
  overflow: hidden;
  animation: gj-rise 450ms ease both;
  animation-delay: var(--d, 0ms);
}
.game-card:hover {
  transform: translateY(-7px);
  border-color: rgba(249,115,22,.5);
  box-shadow: 0 16px 48px rgba(0,0,0,.6), 0 0 0 1px rgba(249,115,22,.25);
  z-index: 2;
}
.game-card:hover .gc-thumb-img { transform: scale(1.07); filter: brightness(.8) saturate(1.4); }
.game-card:hover .gc-play-btn { opacity: 1; transform: translate(-50%,-50%) scale(1); }

.gc-thumb {
  position: relative;
  width: 100%; aspect-ratio: 16 / 10;
  overflow: hidden; flex-shrink: 0;
  border-radius: 0;
}
.gc-thumb-img {
  position: absolute; inset: 0; width: 100%; height: 100%;
  object-fit: cover; display: block;
  transition: transform .4s ease, filter .4s ease;
  filter: brightness(.95) saturate(1.1);
}
.gc-top {
  position: absolute; top: 8px; left: 8px; right: 8px;
  display: flex; justify-content: space-between; align-items: flex-start; z-index: 3;
}
.gc-rank {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
  font-size: 10px; letter-spacing: 2px; text-transform: uppercase;
  background: var(--or); color: #080808; padding: 3px 9px;
  clip-path: polygon(4px 0%,100% 0%,calc(100% - 4px) 100%,0% 100%);
}
.gc-rank.rnew { background: #22c55e; color: #080808; }
.gc-status {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 9px; letter-spacing: 2px; text-transform: uppercase;
  background: rgba(8,8,8,.75); border: 1px solid rgba(255,255,255,.18);
  color: var(--tx2); padding: 3px 7px;
}
.gc-play-btn {
  position: absolute; top: 50%; left: 50%;
  transform: translate(-50%,-50%) scale(.8);
  z-index: 4; opacity: 0;
  transition: opacity .22s ease, transform .22s ease;
  width: 48px; height: 48px; border-radius: 50%;
  background: var(--or); border: none; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 0 0 6px rgba(249,115,22,.25), 0 0 28px rgba(249,115,22,.6);
  text-decoration: none;
}
.gc-play-btn::before {
  content: ''; width: 0; height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 14px solid #080808;
  margin-left: 3px;
}
.gc-thumb::after {
  content: ''; position: absolute; inset: 0;
  background: rgba(8,8,8,.35);
  opacity: 0; transition: opacity .3s;
  z-index: 2;
}
.game-card:hover .gc-thumb::after { opacity: 1; }

.gc-info {
  padding: 12px 14px 16px;
  display: flex; flex-direction: column; gap: 8px;
  flex: 1; background: var(--dark2);
}
.gc-name {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 800;
  font-size: 12px; text-transform: uppercase; letter-spacing: .4px;
  color: var(--tx); line-height: 1.2;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.gc-meta {
  display: flex; align-items: center; justify-content: space-between; gap: 8px;
}
.gc-votes {
  display: flex; align-items: center; gap: 5px;
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 12px; letter-spacing: 1px; color: var(--or);
}
.gc-votes-icon { font-size: 11px; }
.gc-tag {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 9px; letter-spacing: 1.5px; text-transform: uppercase;
  padding: 2px 8px; border-radius: 1px;
}
.gt-a  { background: rgba(249,115,22,.15); color: var(--or2); }

.gc-play-row {
  display: flex; align-items: center; gap: 8px; margin-top: 4px;
}
.gc-play-full {
  flex: 1;
  font-family: 'Barlow Condensed', sans-serif; font-weight: 800;
  font-size: 11px; letter-spacing: 2px; text-transform: uppercase;
  background: var(--or); color: #fff;
  border: none; padding: 8px 0; cursor: pointer;
  transition: all .2s; display: flex; align-items: center; justify-content: center; gap: 6px;
  clip-path: polygon(5px 0%,100% 0%,calc(100% - 5px) 100%,0% 100%);
  text-decoration: none;
}
.gc-play-full:hover {  box-shadow: 0 0 16px rgba(249,115,22,.5); color:#FFF; }
.gc-play-full .play-arrow {
  width: 0; height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 9px solid #080808;
}
.gc-vote-btn {
  min-width: 42px; height: 34px; flex-shrink: 0;
  padding: 0 8px;
  background: transparent; border: 1px solid rgba(249,115,22,.3);
  color: var(--or); cursor: default; transition: all .2s;
  display: flex; align-items: center; justify-content: center; gap: 4px;
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 12px; letter-spacing: .4px;
}

.games-footer {
  display: flex; justify-content: center; margin-top: 40px; position: relative; z-index: 1;
}
.gj-loadmore-btn {
  background: transparent;
  color: var(--tx);
  border: 1px solid rgba(255,255,255,.25);
  padding: 0.9rem 2rem;
  clip-path: var(--clip-both);
  font-weight: 900;
  cursor: pointer;
  transition: background 180ms ease, border-color 180ms ease, transform 160ms ease;
  font-family: 'Barlow Condensed', sans-serif;
  letter-spacing: 0.22em;
  text-transform: uppercase;
}
.gj-loadmore-btn:hover {
  background: rgba(255,255,255,.06);
  border-color: rgba(255,255,255,.6);
  transform: translateY(-1px);
}
.gj-loadmore-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@keyframes gj-rise {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (max-width: 1100px) {
  .games-sec { padding: 64px 40px 80px; }
}
@media (max-width: 800px) {
  .games-header { flex-direction: column; align-items: flex-start; }
}
@media (max-width: 600px) {
  .games-sec { padding: 56px 20px 72px; }
}
`;
